import { render, staticRenderFns } from "./Jump.vue?vue&type=template&id=f556d06e"
import script from "./Jump.vue?vue&type=script&lang=js"
export * from "./Jump.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports